import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';

export default class Timeline {
    constructor() {
        this.section = document.querySelector('.components-block-timeline');
        this.unitSelector = this.section.querySelector('#unit-selector');
        this.timelineItems = this.section.querySelectorAll('.components-block-timeline-item');
        this.groupedUnits = this.groupUnits();
        this.groupedYears = this.groupYears();

        this.ready();
    }

    groupUnits() {
        const elements = this.section.querySelectorAll('.components-block-timeline-item');
        const groupedUnits = {};

        for (const element of elements) {
            const unit = element.dataset.unit;
            const title = element.dataset.unitname;

            if (!groupedUnits[unit]) {
                groupedUnits[unit] = title;
            }
        }

        return groupedUnits;
    }

    groupYears() {
        let elements = this.section.querySelectorAll('.components-block-timeline-item');
        let grouped = {};

        for (const element of elements) {
            if (element.dataset.show == 'true') {
                const year = element.dataset.year;

                if (!grouped[year]) {
                    grouped[year] = year;
                }
            }
        }

        this.groupedYears = grouped;

        return grouped;
    }

    ready() {
        // Adiciona opções no select
        if (this.groupedUnits) {
            for (const unit in this.groupedUnits) {
                if (unit != '') {
                    var option = document.createElement('option');
                    [option.text, option.value] = [this.groupedUnits[unit], unit];
                    this.unitSelector.appendChild(option);
                }
            }
        }

        // Adiciona anos na timeline
        if (this.groupedYears) {
            // Organiza os items na linha do tempo de cada unidade
            let timelineOl = this.section.querySelector('ol');
            let timelineOlLiCopy = timelineOl.querySelector('li').cloneNode(true);

            timelineOl.innerHTML = '';

            for (const year in this.groupedYears) {
                timelineOlLiCopy.dataset.year = year;
                timelineOlLiCopy.querySelector('span').textContent = year;
                timelineOl.appendChild(timelineOlLiCopy.cloneNode(true));
            }

            // Define o primeiro como active
            this.section.querySelectorAll('.year-selector')[0].dataset.active = true;
        }

        // Inicializa o swiper
        let slider = this.section.querySelector('.swiper');
        let navigationPrev = this.section.querySelector('.slider-button-prev');
        let navigationNext = this.section.querySelector('.slider-button-next');

        const swiper = new Swiper(slider, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: '56px',
            allowTouchMove: true,
            navigation: {
                nextEl: navigationNext,
                prevEl: navigationPrev,
            },
        });

        swiper.on('slideChange', () => {
            this.section.querySelectorAll('.year-selector').forEach((yearSelector) => {
                yearSelector.dataset.active = false;
            });

            swiper.update();

            // Filtra os slides que estão visíveis para ter uma referência correta
            let filteredSlides = Array.from(swiper.slides).filter((slide) => slide.dataset.show === 'true');
            this.section.querySelector(
                `.year-selector[data-year="${filteredSlides[swiper.activeIndex].dataset.year}"]`
            ).dataset.active = true;

            // 'Scrolla' para manter os anos visíveis
            let yearSelectorsContainer = this.section.querySelector('.year-selectors');
            let activeYearSelector = this.section.querySelector('.year-selector[data-active="true"]');
            let activeYearSelectorOffset = activeYearSelector.offsetLeft;
            let containerWidth = yearSelectorsContainer.offsetWidth;
            let scrollAmount = activeYearSelectorOffset - containerWidth / 2;
            yearSelectorsContainer.scrollTo({
                left: scrollAmount,
                behavior: 'smooth',
            });
        });

        // Adiciona evento ao mudar de unidade
        this.unitSelector.addEventListener('change', (e) => {
            this.timelineItems.forEach((item) => {
                if (e.target.value === '') {
                    item.dataset.show = true;
                } else {
                    item.dataset.show = item.dataset.unit === e.target.value ? true : false;
                }
            });

            // Atualiza anos da timeline de acordo com a unidade
            this.groupYears();
            let isFirst = false;
            this.section.querySelectorAll('.year-selector').forEach((yearSelector, index) => {
                yearSelector.dataset.show = this.groupedYears[yearSelector.dataset.year] ? true : false;

                // Define o primeiro ano da unidade como active
                if (!isFirst && this.groupedYears[yearSelector.dataset.year]) {
                    yearSelector.dataset.active = true;
                    isFirst = true;
                } else {
                    yearSelector.dataset.active = false;
                }
            });

            swiper.update();

            swiper.slideTo(0);
        });

        // Adiciona evento ao clicar no ano e ir até o primeiro slide do ano
        const yearSelectors = this.section.querySelectorAll('.year-selector');
        yearSelectors.forEach((yearSelector, key) => {
            yearSelector.addEventListener('click', (e) => {
                e.preventDefault();

                yearSelectors.forEach((yearSelector) => {
                    yearSelector.dataset.active = false;
                });

                yearSelector.dataset.active = true;

                // Filtra os slides que estão visíveis para ter uma referência correta
                let filteredSlides = Array.from(swiper.slides).filter((slide) => slide.dataset.show === 'true');
                let index = filteredSlides.findIndex((slide) => {
                    return slide.dataset.show == 'true' && slide.dataset.year === yearSelector.dataset.year;
                });

                swiper.slideTo(index);
            });
        });
    }
}

if (document.querySelector('.components-block-timeline')) {
    new Timeline();
}
